import * as apifetch from './fetch.js';

export async function getSettings() {
    const urlEndpoint = 'settings/list';

    return apifetch.kkFetch(urlEndpoint, 'GET');
}
